import { useState } from "react";
import { Box } from "@mui/material";
import AppHeader from "./components/AppHeader";
import AppRoutes from "./routes/AppRoutes";
import Turnstile from "./components/Turnstile";
import { api } from "./api";

export default function App() {
  const [verified, setIsHumanVerified] = useState(false);

  const verifyHuman = async (turnstileToken) => {
    const { data } = await api.post("/auth/verify-human", {
      turnstileToken,
    });

    sessionStorage.setItem("humanToken", data.token);

    setIsHumanVerified(true);
  };

  if (!verified) {
    return (
      <div style={styles.wrapper}>
        <h2>Verify you are human</h2>

        <Turnstile onVerify={verifyHuman} />
      </div>
    );
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        background: "#f8fafc",
      }}
    >
      <AppHeader />

      <AppRoutes />
    </Box>
  );
}

const styles = {
  wrapper: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: 100,
  },
};
